import { render, staticRenderFns } from "./CheckboxWithTerms.vue?vue&type=template&id=4285a759&scoped=true&"
import script from "./CheckboxWithTerms.vue?vue&type=script&lang=js&"
export * from "./CheckboxWithTerms.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxWithTerms.vue?vue&type=style&index=0&id=4285a759&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4285a759",
  null
  
)

export default component.exports